import { Injectable } from "@angular/core";
import { from, Observable } from "rxjs";
import { TranslateLoader } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class TranslateLoaderService implements TranslateLoader {
  /**
   * Observable returns all the translation keys and its values
   */
  public getTranslation(language: string): Observable<any> {
    return from(import(`../../../translations/default/${language}.json`));
  }
}
